import { Divider, styled } from '@mui/material'
import { PageWithAppBar } from '$common/page-with-app-bar'
import { AppBarBackTitle } from '$common/app-bar/app-bar-back-title'
import { SettingsSection } from '$common/settings-section'
import { ListItemCriticalTextButton } from '$common/buttons'
import { showRemoveMenu } from '$comp/modals/menus/remove-menu'
import { useActiveSessions } from '$logic/auth/react-hook'
import { closeActiveDevices } from '$logic/router'
import { showTerminateSessionsModal } from '$comp/modals/confirmation-dialog'
import { t } from '$i18n'
import { SessionItem } from './session-item'

const InfixDivider = styled(Divider)`
  &:last-child {
    display: none;
  }
`

export function ActiveSessions() {
  const {
    value: activeSessions,
    loading,
    terminateOtherSessions,
    terminateSession,
  } = useActiveSessions()
  const { current, others } = activeSessions || {}

  return (
    <PageWithAppBar
      appBar={
        <AppBarBackTitle
          title={t('settings.sections.security.activeDevices')}
          onBack={closeActiveDevices}
        />
      }
    >
      {/* TODO: Implement skeleton */}
      {!loading && current ? (
        <>
          <SettingsSection headerText={t('activeSessions.currentDevice')}>
            <>
              <SessionItem
                ip={current.identity?.ip}
                userAgent={current.identity?.userAgent}
                date={current.updatedAt}
              />
              <Divider />
              <ListItemCriticalTextButton
                text={t('activeSessions.deactivateOtherDevices')}
                onClick={() =>
                  showTerminateSessionsModal(() =>
                    terminateOtherSessions().then(() =>
                      analite('PROFILE_SETTING_DEACTIVE_ALL_SESSIONS'),
                    ),
                  )
                }
              />
            </>
          </SettingsSection>
          {others ? (
            <SettingsSection
              headerText={t('activeSessions.otherActiveDevices')}
            >
              <>
                {others.map(({ updatedAt, identity, selector }) => (
                  <>
                    <SessionItem
                      ip={identity?.ip}
                      userAgent={identity?.userAgent}
                      date={updatedAt}
                      onClick={() =>
                        showRemoveMenu({
                          onRemove: () =>
                            terminateSession(selector).then(() =>
                              analite('PROFILE_SETTING_DEACTIVE_ONE_SESSION'),
                            ),
                        })
                      }
                    />
                    <InfixDivider />
                  </>
                ))}
              </>
            </SettingsSection>
          ) : null}
        </>
      ) : null}
    </PageWithAppBar>
  )
}
